<template>
  <div class="courseBlock">
    <div class="courseBanner">
      <div class="curriculumType" style="display: flex;padding: 0;box-sizing: border-box;" >
        <div style="width: 900px;height: 345px" v-if="banners.length > 0">
          <a-carousel dots autoplay style="" >
            <div style="overflow: hidden;width: 100%;height: 345px;" v-for="(item, index) in banners" :key="index">
              <img @click="open(item.PageUrl)" :src="item.ImageUrl" alt="" style="width: 100%;height: 345px;" > 
            </div>
          </a-carousel>
        </div>
        <img v-else src="http://adzjgc.tumengkj.com/images/banner1.png" alt="" style="width: 100%;height: 345px;">
        <div class="personInfo">
          <img style="width: 64px;height: 64px;border-radius: 50%;" v-if="userInfo.avatar" :src="userInfo.avatar" />
          <img style="width: 64px;height: 64px;border-radius: 50%;" v-else src="../../assets/image/defaultHaderImg.png" />
          <div style="font-weight: 600;font-size: 15px">{{ userInfo.username }}</div>
          <div v-if=" userInfo.className">{{ userInfo.college }} ~ {{ userInfo.className }}</div>
          <div v-if=" userInfo.SchoolName">{{ userInfo.SchoolName }}</div>
        </div>
      </div>
    </div>
    <div class="courseBanner" style="padding: 0;" v-if="noticeList.length">
      <div class="noticelist">
        <a-carousel autoplay :dot-position="'right'" :dots="false">
          <div class="noticitem" v-for="notice in noticeList" :key="notice.Id" @click="toNoticeDetail(notice.Id)">{{ notice.Title }}</div>
        </a-carousel>
      </div>
    </div>
    <div class="curriculum">
      <div class="curriculumType">
        <div class="curriculumTypeList">
          <div class="curriculumTab">
            <!-- <div class="direction">方向</div>
            <div class="verticalLine"></div> -->
            <div class="curriculumList" :class="isDevelop ? 'developStyle' : ''">
              <div class="curriculumItem" :class="activeId == item.id ? 'activeTab' : ''" v-for="(item, index) in curriculumList"
                :key="index" @click="handleSelect(item.id)">{{ item.name }}</div>
            </div>
          </div>
          <div v-if="!isDevelop" class="develop" @click="handleDevelop(true)">
            <span class="developText">展开</span>
            <DownOutlined />
          </div>
          <div v-if="isDevelop" class="develop" @click="handleDevelop(false)">
            <span class="developText">收起</span>
            <UpOutlined />
          </div>
        </div>
        <div class="classify">
          <div class="classifyItem">共{{courseLists.length}}门课程</div>
          <!-- <div class="classifyItem" v-for="(item, index) in sortOrder" :key="index" @click="handleSort(item.id)"
            :class="item.id == sortType ? 'activeSort' : ''">{{ item.name }}</div> -->
        </div>
      </div>
    </div>
    <a-spin :spinning="spinning">
      <div class="courseCore">
        <div class="courseItemBlock" v-for="(item, index) in courseLists" :key="index">
          <div class="courseItem"  @click="handleDetail(item.id)">
            <img class="courseImg" :src="item.img" alt="">
            <div class="courseInfo">
              <div class="courseName">{{ item.name }}</div>
              <div class="otherInfo">
                <div class="teacher">{{ item.teacherName }}</div>
                <div class="classHour">共{{ item.allClassHour }}个课时</div>
              </div>
              <div class="Learned">已学{{ (item.progress * 100).toFixed(0) }}%</div>
              <a-progress :strokeWidth="4" :percent="item.progress * 100" :show-info="false" strokeColor="#0960bd"
                trailColor="#E5E5E5" />
              <div class="NextLesson" v-if="item.progress>0&&item.currentClassHour">学习进度：{{ item.currentClassHour.name }}</div>
            </div>
          </div>
        </div>
        <div class="courseItemBlock" ></div>
        <div class="courseItemBlock" ></div>
        <div class="courseItemBlock" ></div>
      </div>
    </a-spin>

    <div class="fixedBtns">
      <a class="div" href="tencent://AddContact/?fromId=45&fromSubId=1&subcmd=all&uin=1121631189" target="_blank" >
        <svg t="1750391641524" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9741" width="28" height="28"><path d="M841.632 375.072a357.76 357.76 0 0 0-329.92-219.52c-146.912 0-275.488 89.376-329.856 219.52a178.368 178.368 0 0 1 61.792-10.976 29.76 29.76 0 0 1 29.792 29.76v297.888a29.76 29.76 0 0 1-29.76 29.76 178.72 178.72 0 0 1-141.344-288.128l0.256-1.408a417.152 417.152 0 0 1 818.432 0.64l0.128 0.8a177.952 177.952 0 0 1 37.408 109.408 178.336 178.336 0 0 1-63.36 136.512c-4.256 11.008-12.352 25.6-25.44 47.68a417.504 417.504 0 0 1-252.512 189.568l-31.584 8.64a29.952 29.952 0 0 1-5.664 1.024c-7.584 2.528-15.552 3.84-23.584 3.808h-89.344a74.464 74.464 0 0 1 0-148.928h89.344c39.04 0 71.488 30.144 74.304 69.12A358.4 358.4 0 0 0 803.2 720a182.72 182.72 0 0 1-23.36 1.504 29.76 29.76 0 0 1-29.792-29.792v-297.856a29.76 29.76 0 0 1 29.76-29.792c21.76 0 42.56 3.84 61.824 10.976z m10.176 262.656a119.2 119.2 0 0 0-42.208-210.304v230.784c15.296-3.936 29.664-10.88 42.24-20.48z m-384.736 202.944a14.88 14.88 0 1 0 0 29.792h89.344a14.88 14.88 0 1 0 0-29.76h-89.344zM124.48 542.816a119.2 119.2 0 0 0 89.344 115.392v-230.784a119.2 119.2 0 0 0-89.344 115.392z" fill="#000000" p-id="9742"></path></svg>
        <div>在线客服</div>
      </a>
      <div class="div">
        <a-tooltip color="#0960bd" placement="left" title="18321336435">
          <a href="tel:18321336435" style="display: flex;flex-direction: column;align-items: center;gap: 3px;color: #333;">
            <svg t="1750391937612" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2099" width="28" height="28"><path d="M805.36064 30.72 239.66208 30.72C200.62208 30.72 168.96 62.68928 168.96 102.08256l0 820.82304c0 39.39328 31.66208 71.36256 70.70208 71.36256l565.69856 0c39.04 0 70.70208-31.96416 70.70208-71.36256L876.06272 102.08256C876.0576 62.68928 844.40064 30.72 805.36064 30.72L805.36064 30.72zM540.22144 958.61248c-29.312 0-53.05856-23.99232-53.05856-53.53984 0-29.54752 23.74656-53.5296 53.05856-53.5296 29.30176 0 53.04832 23.9872 53.04832 53.5296C593.26976 934.62528 569.46176 958.61248 540.22144 958.61248L540.22144 958.61248zM805.36064 708.8128c0 39.3984-31.66208 71.36256-70.69696 71.36256L310.35904 780.17536c-39.04 0-70.69696-31.96416-70.69696-71.36256L239.66208 173.44512c0-39.3984 31.66208-71.36256 70.69696-71.36256l424.30976 0c39.03488 0 70.69696 31.96416 70.69696 71.36256L805.36576 708.8128 805.36064 708.8128z" fill="#262536" p-id="2100"></path></svg>
            <div>技术支持</div>
          </a>
        </a-tooltip>
      </div>
      <div class="div" @click="fixedbtn.aichat">
        <svg t="1750391481299" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6818" width="28" height="28"><path d="M831.274667 106.624c58.752 0 106.368 45.354667 106.368 101.333333v472.96c0 55.978667-47.616 101.376-106.368 101.376h-202.154667l-203.861333 129.450667a36.992 36.992 0 0 1-33.706667 2.858667 34.133333 34.133333 0 0 1-20.906667-25.386667l-0.512-5.589333v-101.333334H192.768c-54.826667 0-100.693333-39.68-105.941333-91.648l-0.469334-9.728V207.957333c0-55.978667 47.658667-101.333333 106.410667-101.333333h638.506667z m6.528 64.426667H186.197333c-19.968 0-36.181333 15.36-36.181333 34.346666V686.506667c0 18.986667 16.213333 34.389333 36.181333 34.389333h217.216c19.968 0 36.181333 15.36 36.181334 34.346667v73.130666l160.981333-101.717333a37.12 37.12 0 0 1 13.013333-5.077333l7.04-0.682667h217.173334c19.968 0 36.224-15.36 36.224-34.389333V205.397333c0-18.986667-16.213333-34.346667-36.224-34.346666z" p-id="6819"></path><path d="M338.730667 611.882667c17.066667 0 26.496-8.746667 33.152-31.018667l18.005333-54.954667h113.408l18.261333 54.954667c6.4 22.016 16.298667 31.018667 33.578667 31.018667 18.261333 0 30.336-10.88 30.336-27.946667 0-6.613333-1.664-14.464-4.949333-24.618667l-81.493334-233.514666c-10.197333-30.293333-24.405333-42.581333-51.114666-42.581334-27.008 0-41.472 12.544-51.626667 42.581334l-81.493333 233.514666c-4.010667 12.074667-5.674667 19.413333-5.674667 25.813334 0 16.085333 12.117333 26.752 29.610667 26.752z m65.365333-133.546667l41.173333-130.730667h3.072l40.96 130.730667H404.138667z m259.029333 133.077333c20.138667 0 31.744-12.8 31.744-34.56V317.952c0-21.76-11.818667-34.56-31.957333-34.56-20.394667 0-32 12.8-32 34.56v258.858667c0 21.76 11.861333 34.56 32.213333 34.56z" p-id="6820"></path></svg>
        <div>AI咨询</div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, unref, toRaw } from 'vue';
import { DownOutlined, UpOutlined } from '@ant-design/icons-vue';
import { useRouter } from 'vue-router'
import defHttp from "@/utils/http.js";
import { message } from 'ant-design-vue';
export default defineComponent({
  components: {
    DownOutlined,
    UpOutlined
  },
  setup() {

    const userInfo = ref({
      className:'',
      avatar:'',
      username:''
    })
    const getBaseInfo=()=>{
      defHttp.get('/student/account/userInfo').then(data=>{
        if(data.Success){
          userInfo.value=data.Data
          localStorage.setItem('userInfo',JSON.stringify(userInfo.value))
        }else{
          message.error(`${data.Message}`)
        }
      }).catch(err => {})
    }
    let hadUserInfo = localStorage.getItem('userInfo')
    if (hadUserInfo) {
      try {
        userInfo.value = {...JSON.parse(hadUserInfo)}
      } catch (error) {
        getBaseInfo()
      }
    } else {
      getBaseInfo()
    }
    
    

    const router = useRouter()

    const isTeacher = window.localStorage.getItem('tokenType') == 'teacher'
    if (isTeacher) {
      router.push('/teacher/careerpath/index')
      return
    }

    const sortOrder = ref([
      { name: '最新上线', id: 1 },
      { name: '学习人数', id: 2 },
    ])
    const sortType = ref(1)
    const visible = ref(false);
    const spinning = ref(false)
    const isDevelop = ref(false)
    const curriculumList = ref([
      { name: '全部', id: -1 }
    ])
    const courseLists = ref([])
    const activeId = ref(-1)
    const showModal = () => {
      visible.value = true;
    };
    const handleOk = e => {
      visible.value = false;
    };

    const handleSelect = (id) => {
      activeId.value = id
      getCourseList()
    }

    onMounted(() => {
      getDirectionList()
      if (localStorage.getItem('token-smartvg')) {
        getCourseList()
      }
    })

    const getDirectionList = () => {
      defHttp.get('/student/direction').then(data => {
        if (data.Success) {
          curriculumList.value.push(...data.Data)
        } else {
          message.error(`${data.Message}`)
        }
      })
    }

    const handleSort = (type) => {
      sortType.value = type
      getCourseList()
    }

    const getCourseList = () => {
      spinning.value = true
      defHttp.get('/student/course/list', { params: { directionId: activeId.value, number: sortType.value } }).then(data => {
        spinning.value = false
        if (data.Success) {
          courseLists.value = data.Data
          courseLists.value.forEach(item => {
            if(item.progress=='NaN'){
              item.progress=0
            }
            item.currentClassHour=item.currentClassHour[0]
          })
        } else {
          message.error(`${data.Message}`)
        }
      }).catch(err => { spinning.value = false })
    }

    const handleDetail = (id) => {
      router.push({ path: '/courseDetail', query: { courseId: id } })
    }

    const handleDevelop = (type) => {
      isDevelop.value = type
    }

    const noticeList = ref([])
    const getnoticeList = () => {
      defHttp.get('/system/Notice/List', { params: { page: 1, limit: 10 } }).then(data => {
        if (data.Success) {
          noticeList.value = data.Data.Rows
        } 
      }).catch(err => {  })
    }
    getnoticeList()
    const toNoticeDetail = (id) => {
      router.push({ path: '/noticeDetail', query: { id } })
    }

    const banners = ref([])
    const getBanners=()=>{
      defHttp.get('/trainer/system/adbanners').then(data=>{
        if(data.Success){
          banners.value=data.Data.Rows
        }else{
          message.error(`${data.Message}`)
        }
      }).catch(err => {})
    }
    getBanners()

    const fixedbtn = ref({
      livekf () {
        window.open('tencent://AddContact/?fromId=45&fromSubId=1&subcmd=all&uin=1121631189')
      },
      makecall () {

      },
      aichat () {
        window.open('https://chat.deepseek.com/')
      }
    })
    return {
      fixedbtn,
      banners,
      open:(url) => {window.open(url)},
      visible,
      showModal,
      toNoticeDetail,
      handleOk,
      curriculumList,
      activeId,
      handleSelect,
      handleDetail,
      getCourseList,
      spinning,
      courseLists,
      sortOrder,
      sortType,
      handleSort,
      handleDevelop,
      isDevelop,
      userInfo,
      noticeList
    };
  },
});
</script>

<style scoped>
.fixedBtns {
  position: fixed;
  right:0;
  top:50%;
  transform: translateY(-50%);
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-right: 0px;
  border-radius: 12px 0 0 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  padding: 8px;
 
}
 .div {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 12px;
    gap: 2px;
    color: #333;
  }
.noticelist {
  width: 70%;
  min-width: 1200px;
  background-color: #fff;
  height: 50px;
  margin-bottom: 16px;
}
.noticitem {
  width: 100%;
  height: 50px;
  padding: 0 16px;
  box-sizing: border-box;
  line-height: 50px;
  cursor: pointer;
}
.courseBannerImg {
  flex: 1;
  object-fit: cover;
}
.courseBanner{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
}
.personInfo {
  margin-left: 16px;
  width: 284px;
  height: 345px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-sizing: border-box;
  padding: 24px;
}
.personInfo div{
  margin-top: 12px;
  text-align: center;
}

.courseBlock {
  min-height: 100%;
  background-color: #f0f2f5;
}

.curriculum {
  width: 100%;
  padding: 21px 0 12px 0;
  /* height: 98px; */
  background: #FFFFFF;
  box-shadow: 0px 4px 4px rgba(217, 217, 217, 0.16);
}

.curriculumType {
  width: 70%;
  min-width: 1200px;
  margin: 0 auto;
}

.curriculumTypeList {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
}

.curriculumTab {
  display: flex;
}

.direction {
  min-width: 40px;
  font-weight: 700;
  font-size: 18px;
  line-height: 33px;
  color: #333333;
}

.verticalLine {
  width: 2px;
  height: 31px;
  background: #CCCCCC;
  margin: 0 20px;
}

.curriculumList {
  display: flex;
  max-height: 45px;
  overflow: hidden;
  flex-wrap: wrap;
}

.curriculumItem {
  margin-right: 10px;
  padding: 0px 16px;
  font-size: 14px;
  line-height: 30px;
  text-align: center;
  color: #545c63;
  cursor: pointer;
  margin-bottom: 12px;
  border-radius: 15px;
}

.curriculumItem:hover{
  color: #FFFFFF;
  font-weight: bold;
  background: #545c63;
  border-radius: 15px;
}

.activeTab {
  color: #FFFFFF;
  font-weight: bold;
  background: #545c63;
  border-radius: 15px;
}

.develop {
  min-width: 50px;
  font-weight: 400;
  font-size: 12px;
  line-height: 33px;
  color: var(--theme);
  cursor: pointer;
}

.developText {
  margin-right: 10px;
}

.classify {
  margin-top: 18px;
  display: flex;
  justify-content: flex-end;
}

.classifyItem {
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #999999;
  margin-left: 28px;
  cursor: pointer;
}

.courseCore {
  width: 70%;
  min-width: 1200px;
  margin: 0 auto;
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  position: relative;
}
.courseItemBlock{
  width: 22.5%;
  min-width: 275px;
  margin: 0 10px;
  display: flex;
  justify-content: center;
}
.courseItem {
  width:100%;
  max-height: 300px;
  border-radius: 10px;
  background: #FFFFFF;
  box-shadow: 0px 4px 11px rgba(199, 215, 225, 0.31);
  overflow: hidden;
  margin-bottom: 20px;
  cursor: pointer;
}

.courseImg {
  width: 100%;
  height: 149px;
  object-fit: cover;
}

.courseInfo {
  padding: 13px 12px 21px 12px;
}

.courseName {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #333333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.otherInfo {
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #999999;
}

.Learned {
  margin-top: 18px;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: var(--theme);
}

.NextLesson {
  margin-top: 8px;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #999999;
}

.teacher {
  max-width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.activeSort {
  color: var(--theme);
}

.developStyle {
  max-height: none !important;
}

</style>